import React, { useState } from 'react';

import { EditConfirmProps } from 'types';
import Button from 'components/Button/Button';
import { listAppsInString, useErrorModal } from 'utils';
import { AmplitudeEventCategories, AmplitudeEventProperties, logAmplitudeEvent } from 'utils/Amplitude';
import modalCommonStyles from './ModalCommon.module.scss';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const EditConfirm: React.FC<EditConfirmProps & ComponentProps> = ({
  callback,
  styles,
  closeModal,
  affectedApps,
  hasBrands,
  venueName,
  item
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const errorModalHandler = useErrorModal();

  const [title, body] = [
    `Publish?`,
    `This item will be published to ${listAppsInString(affectedApps, hasBrands, venueName)}.`
  ];

  return (
    <div
      data-testid="edit-confirm"
      role="dialog"
      aria-labelledby="edit-confirm-title"
      aria-describedby="edit-confirm-description"
    >
      <h2 id="edit-confirm-title" className={styles.NoMargin}>
        {title}
      </h2>
      <p id="edit-confirm-description" data-testid="edit-confirm-copy">
        {body}
      </p>
      <div className={styles.ButtonRow}>
        <Button
          onClick={() => {
            logAmplitudeEvent({
              name: 'publish item (cancel)',
              category: AmplitudeEventCategories.MM_SIDE_PANEL_ITEMS,
              properties: {
                [AmplitudeEventProperties.ITEM_POS_ID]: item?.posId || '',
                [AmplitudeEventProperties.ITEM_NAME]: item?.name || '',
                [AmplitudeEventProperties.APPS]: item?.variablesByApp.map(({ app }) => app.name) || []
              }
            });
            closeModal();
          }}
          level="low"
        >
          <span>Cancel</span>
        </Button>
        <Button
          onClick={async () => {
            setIsLoading(true);
            const error = await callback();
            setIsLoading(false);
            if (error) {
              errorModalHandler(error.error, error.currentVenue);
            } else {
              closeModal();
            }
            logAmplitudeEvent({
              name: 'publish item (confirm)',
              category: AmplitudeEventCategories.MM_SIDE_PANEL_ITEMS,
              properties: {
                [AmplitudeEventProperties.ITEM_POS_ID]: item?.posId || '',
                [AmplitudeEventProperties.ITEM_NAME]: item?.name || '',
                [AmplitudeEventProperties.APPS]: item?.variablesByApp.map(({ app }) => app.name) || [],
                [AmplitudeEventProperties.RESULT]: error ? 'failure' : 'success'
              }
            });
          }}
        >
          <span className={modalCommonStyles.ConfirmButton}>
            {isLoading ? <i className="mm-circle-o-notch mm-spin" /> : 'Confirm'}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default EditConfirm;
